<template>
    <div>
      <div class>
        <div class="five">
          <div class="row d-flex flex-wrap align-items-stretch">
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Nom :</p>
                    <!-- <d-input v-if="edit" type="text" v-model="request.applicantLastName" /> -->
                    <span>{{
                      request.applicantLastName ? request.applicantLastName : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Prénom :</p>
                    <!-- <d-input v-if="edit" type="text" v-model="request.applicantFirstName" /> -->
                    <span>{{
                      request.applicantFirstName ? request.applicantFirstName : "Non renseigné"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <div class="col-2 svg-wrapper">
                    <svg
                    width="44px"
                    height="44px"
                    viewBox="0 0 44 44"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                    <title>Iconspace_Calendar</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Antarmuka_One-Color-UI-element-1"
                        transform="translate(-338.000000, -242.000000)"
                      >
                        <g
                          id="Iconspace_Calendar"
                          transform="translate(336.000000, 240.000000)"
                        >
                          <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                          <path
                            d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                            id="Shape"
                            fill="#303778"
                            fill-rule="nonzero"
                          />
                          <polygon
                            id="Shape"
                            fill="#303778"
                            points="10 18 18 18 18 26 10 26"
                          />
                        </g>
                      </g>
                    </g>
                    </svg>
                  </div>
                  <div class="col-10">
                    <p>Date:</p>
                    <d-datepicker
                      v-if="edit"
                      id="datepicker"
                      class="pr-1"
                      v-model="request.creationDate"
                      placeholder="Date"
                      :input-class="['form-control', 'datepicker', 'py-3']"
                      :language="fr"
                      small
                    ></d-datepicker>
                    <span v-else>{{
                      new Date(request.creationDate).toLocaleDateString("fr-FR")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Structure :</p>
                    <select v-if="edit" class="form-control" v-model="selStr" @change="handleSelectStructure" name="structure">
                      <option v-for="str in allStructures" :value="str">{{ str.name }}</option>
                    </select>
                    <span v-else>{{
                      // request.selectedStructure.name ? request.selectedStructure.name: request.structureID
                      request.structureName ? request.structureName : request.selectedStructure.name
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Montant initial :</p>
                    <d-input v-if="edit" type="text" v-model="request.amount" />
                    <span v-else>{{
                      request.amount ? request.amount : "Non renseigné"
                    }} €</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Montant dépensé :</p>
                    <d-input v-if="edit" type="text" v-model="request.actualAmount" />
                    <span v-else>{{
                        request.actualAmount ? request.actualAmount : "Non renseigné"
                    }} €</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="request.effectiveAmount">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Montant rendu à :</p>
                    <span>{{
                        request.returnToEmployee ? "Salarié" : "l'employeur"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6" v-if="request.effectiveAmount">
              <div class="step4-card">
                <div class="row">
                  <svg-icon />
                  <div class="col-10">
                    <p>Montant rendu :</p>
                    <span>{{
                        request.effectiveAmount ? request.effectiveAmount : "Non renseigné"
                    }} €</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TimeUtils from '../../utils/TimeUtils';
  import SvgIcon from '../shared/SvgIcon.vue';
  
  export default {
    name: 'RecapitulatifRetourRegieRequest',
    components: {
      SvgIcon,
    },
    props: {
      request: Object,
      edit: Boolean,
      all: Boolean,
      showLastTwo: Boolean,
      allStructures: Array,
    },
    data() {
      return {
        selStr: null,
      };
    },
    methods: {
      formatDate(date) {
        return TimeUtils.formatDate(date);
      },
      handleSelectStructure() {
        this.request.structureID = this.selStr.reference;
        this.request.structureName = this.selStr.name;
      }
    },
  };
  </script>
  
  <style scoped>
  .step4-card {
    padding: 15px;
    min-height: 70px;
    border-radius: 0;
    border-left: 5px solid #303778;
    margin-bottom: 5px;
    background-color: #f6f8ff;
    height: 100%;
  }
  .svg-wrapper svg {
    height: 20px;
  }
  
  .step4-card p {
    color: #32356b;
  }
  .step4-card span {
    color: #6c7899;
  }
  </style>
  